var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "component" }, [
    _c("div", { staticClass: "tab_information" }, [
      (_vm.componentData.personinfo && _vm.componentData.personinfo.length) ||
      (_vm.componentData.marital && _vm.componentData.marital.length)
        ? _c("div", { staticClass: "square" })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "info-content" }, [
        _vm.componentData.personinfo && _vm.componentData.personinfo.length
          ? _c(
              "div",
              { staticClass: "info-content-item" },
              [
                _c("div", { staticClass: "info-content-item-title" }, [
                  _vm._v("基本信息")
                ]),
                _vm._v(" "),
                _c("portrait-labels", {
                  attrs: { labelList: _vm.componentData.personinfo }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.componentData.marital && _vm.componentData.marital.length
          ? _c(
              "div",
              { staticClass: "info-content-item" },
              [
                _c("div", { staticClass: "info-content-item-title" }, [
                  _vm._v("婚育状况")
                ]),
                _vm._v(" "),
                _c("portrait-labels", {
                  attrs: { labelList: _vm.componentData.marital }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }